import React, { Component } from "react";
import { Divider, Table, TableContainer, TableCell, TableHead, TableBody, TableRow, Typography, Paper } from "@material-ui/core";
import { withRouter, Redirect, Link } from 'react-router-dom';
import { connect } from "react-redux";
import { LoadingCard, CopyrightWidget } from "../components";

import { trackPage, getQuizzesListResults } from "../actions";
import { deviceData, getThisYear } from "../common";

class QuizListScreen extends Component {
    state = {
        show: false,
        loadingtext: ["Loading Quizzes"],
        title: "Quiz Results",
        quizList: [],
        rendered: false
    }

    componentDidMount = async () => {
        const { deckid } = this.props.location;
        const { mcid, key } = this.props.auth_feedback;
        let data = { deckid, mcid, key }
        let tracking = deviceData(this.props.location, 'navigate');

        tracking.action = 'navigate';
        tracking.detail = deckid
        tracking.detailvar = 'Quiz Deck ID';

        let tobj = {
            mcid: mcid,
            key: key,
            deckid: deckid,
            tracking: tracking
        }

        await this.props.trackPage(tracking);
        return this.props.getQuizzesListResults(data, tracking);
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.quizList !== this.props.quizList) {
            return this.setState({ ...this.state, quizList: this.props.quizList, rendered: true })
        }

        if (prevProps.quizList === this.props.quizList && !this.state.rendered) {
            return this.setState({ ...this.state, show: true, rendered: true })
        }

        if (prevState.quizList !== this.state.quizList) {
            return this.setState({ ...this.state, show: true })
        }
    }

    componentWillUnmount = async () => {
        this.setState({ show: false, quizList: [], rendered: false })
    }  

    render() {
        try {
    
            if (!this.state.show) {
                return (
                    <LoadingCard textarray={this.state.loadingtext} /> 
                )
            } else {
                return (
                    <div className=" aua-overflow" id="QuestionDiv">
                        <Typography className="homeDividerText">{this.state.quizList[0].title}</Typography>
                        <p>
                            <strong className="text-blue">
                                {this.state.quizList[0].subtitle}
                            </strong>
                        </p>
                        <p>
                            <small>
                                Last Completed on: {this.state.quizList[0].completedON}
                            </small>
                        </p>
                        <div className="question-container" >
                            <TableContainer className="margin-bottom-24" component={Paper} st
                            yle={{ "width": "100%" }}>
                                <Table className="table table-striped" aria-label="quiz list table" style={{width: "100%"}} >
                                    <TableHead>
                                        <TableRow>
                                            {/* <TableCell align="left">Quiz Title</TableCell> */}
                                            <TableCell align="center">Completed On</TableCell>
                                            <TableCell align="center">Score</TableCell>
                                            <TableCell align="center"></TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {this.state.quizList.map((quiz, index) => {
                                            const qobj = {
                                                pathname: "/quizResultScreen",
                                                state: {
                                                    instance: quiz.instance,
                                                    deckid: quiz.deckid,
                                                    gamemode: quiz.gamemode
                                                }
                                            }
                                            return (
                                                <TableRow key={`quiz-${index}`}>
                                                    {/* <TableCell align="left">
                                                        {quiz.title}
                                                    </TableCell> */}
                                                    <TableCell align="center">{quiz.completedON}</TableCell>
                                                    <TableCell align="center">{quiz.percentage}%</TableCell>
                                                    <TableCell align="center">
                                                        <Link 
                                                            to={qobj}
                                                        > 
                                                            View Results
                                                        </Link> 
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>  

                                </Table>
                            </TableContainer>
                        </div>

                        <CopyrightWidget 
                            style={{width: "auto;"}}
                            year={getThisYear()}
                            textAlign={'center'}
                            className="margin-top-8 padding-top-8 padding-bottom-24"
                        />
                    </div>
                )
            }
        } catch (err) {
            console.log(`QuizListScreen render error: `, err);
            return <Redirect to="/home" />  
        }
    }
}

const mapStateToProps = state => {
    const { quizList } = state.decks;
    const { auth_feedback } = state.auth;

    return {
        quizList,
        auth_feedback
    }
}

export default connect(
    mapStateToProps, 
    { getQuizzesListResults, trackPage }
)(QuizListScreen);